import React from "react";

import Layout from "../components/layout";
import SEO from "../components/seo";
import Illustration from "../images/formal_13516081.jpg";
import Resume from "../images/CV-short.pdf";

function AboutPage() {
  return (
    <Layout>
      <SEO
        keywords={[`rabbi`, `mayoza`, `rabbi fijar mayoza`, `pollycarpus`]}
        title="About"
      />
      <div className="flex-1 w-full bg-white">
        <section className="flex flex-col items-center md:flex-row mx-auto px-4 py-8 mx-auto md:px-8 md:py-16 max-w-5xl">
          <figure className="mb-8 md:mr-8 w-1/3">
            <img alt="A dog relaxing" src={Illustration} />
          </figure>
          <div className="md:w-2/3 md:mr-8">
            <blockquote className="pl-4 font-serif leading-loose text-justify border-l-4 border-gray-900">
              I was born in Jakarta, grew in Surabaya, study computer science in Bandung and finally graduated from Institut Teknologi Bandung. Being raised from a multicultural family, having been lived in different cities, and having many friends from diverse cultures make me a flexible, adaptive, and tolerant. 
              <br></br><br></br>Anyway, I study computer science because I like math, logical games and riddles since I was little. I started learning programming in my first year of college. Surprisingly I can progress from the basics to more difficult works. Since then my interest in tech world grew and grew. I am very excited to be a software engineer or deal with A.I stuff, but for me it does not matter of programming thing. Basically, solving any real problems with my knowledge is my passion. 
              <br></br><br></br>During my time in college, definitely I do not just study. I pushed myself to challenge by joining competitions and experience with some activities and internships. TLDR see my resume to know my journey.
            </blockquote>
            <div className="mt-5 sm:mt-8 sm:flex sm:justify-start lg:justify-start">
              <div className="rounded-md shadow">
                <a
                  className="block inline w-full flex items-center justify-center px-8 py-3 border-2 text-sm border-black font-medium rounded-md text-gray-700 bg-white hover:bg-blue-700 hover:text-white hover:border-transparent md:py-4 md:text-lg md:px-10"
                  href={Resume}>
                  See my resume
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default AboutPage;
